// Formatting helpers used across views.

import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'MMM d, yyyy');
  } catch {
    return '—';
  }
}

export function fmtRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return `${formatDistanceToNowStrict(parseISO(iso))} ago`;
  } catch {
    return '—';
  }
}

export function fmtMoney(cents: number, currency: string = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

/** Format a dollar amount (already in dollars, not cents). */
export function fmtDollars(amount: number, currency: string = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}

export function fmtQty(n: number): string {
  return new Intl.NumberFormat('en-US').format(n);
}

export function customerInitials(args: { firstName?: string | null; lastName?: string | null; email?: string | null }): string {
  const first = (args.firstName ?? '').trim();
  const last = (args.lastName ?? '').trim();
  if (first || last) {
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || '?';
  }
  const email = (args.email ?? '').trim();
  if (email) return email.charAt(0).toUpperCase();
  return '?';
}
